import { appBaseUrl } from "@/variables"

import { HelpClient } from "@/lib/api"


const initialState = () => ({
    api: new HelpClient(appBaseUrl),

});

// State object
const state = {
    api: new HelpClient(appBaseUrl),
}

// Getter functions
const getters = {
    getApi(state) {
        return state.api;
    },

    
}

// Actions 
const actions = {

    async createHelpRequest({state, commit},  model){

        const response = await state.api.createHelpRequest(model);

        commit('createHelpRequestCompleted', response);

    },

    

}

// Mutations
const mutations = {

    createHelpRequestCompleted(state, result){
        console.log(result);
    },
    

    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },
    loadToken(state){
        let token = window.localStorage.getItem('token') || ""
        state.api.instance.defaults.headers.common = {'Authorization': `Bearer ${token}`};
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}